import store from '@/store';
import requestDefault from '@/shared/utils/request';

const { mobile } = store.state.base.originUserInfo;

export const send = (phone: string, scene: string): Promise<boolean> => requestDefault.postGate(
  'f.auth.code.send',
  {
    phone,
    scene,
  },
  {
    loadingMessage: '发送中',
  },
);

export const check = (code: string): Promise<boolean> => {
  if (mobile) {
    return requestDefault.postGate('f.auth.code.check', {
      code,
      phone: mobile,
    });
  }
  return Promise.resolve(false);
};

export const sendReset = (): Promise<boolean> => {
  if (mobile) {
    return send(mobile, 'reset_pwd');
  }
  return Promise.resolve(false);
};

const SmsApi = {
  send,
  check,
  sendReset,
};

export default SmsApi;
